import { render } from "./Claim_1_Submitted_bills.vue?vue&type=template&id=b6cfc4b6&ts=true"
import script from "./Claim_1_Submitted_bills.vue?vue&type=script&lang=ts"
export * from "./Claim_1_Submitted_bills.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__